import { bindActionCreators, Dispatch } from 'redux';
import { NotificationActions } from '../store/notification/notification-actions';

const f = () => {
    return '';
};

export const mockTheme: any = {
    zIndex: {
        drawer: {}
    },
    transitions: {
        create: f,
        easing: {},
        duration: {}
    },
    spacing: {
        unit: {}
    },
    palette: {
        primary: {},
        secondary: {},
        common: {},
        background: {
            default: {}
        },
        text: {}
    },
    breakpoints: {
        up: f
    },
    mixins: {
        toolbar: {},
        gutters: f
    },
    typography: {
        pxToRem: f
    },
};

/**
 * This type excludes the 'classes' property that is not
 * required in the interface (the withstyles provides the classes)
 */
export type ExcludeClasses<T> =
    Pick<T, Exclude<keyof T, 'classes' | 'actions' | 'notification'>>;

/**
 * This method map a class to an map
 *
 * For example, if we has a class:
 * ```
 * class T {
 *  method1(...) {}
 *  method2(...) {}
 * }
 * ```
 *
 * And we call `toMap(T)`, it will return:
 *
 * ```
 * {
 *  method1: {},
 *  method2: {}
 * }
 * ```
 *
 * This is usefull to use in action mappers, for example:
 *
 * ```
 * const mapDispatchToProps = (dispatch: Dispatch) => ({
 *  actions: bindActionCreators(toMap(T), dispatch)
 * });
 * ```
 * @param actionHolderBuilder the class to map
 * @returns an object with keys as the same as the functions of the instance
 */
export function toMap<T>(actionHolderBuilder: { new(): T; }) {

    const actionHolder: any = new actionHolderBuilder();

    const t = {};
    Object.keys(actionHolder.__proto__).forEach(p => {
        t[p] = actionHolder.__proto__[p].bind(actionHolder);
    });
    return t;
}

export interface WithActions<T> {
    actions: T,
    notification: NotificationActions
}

/**
 * This is a shorthand for:
 *
 * ```
 * (dispatch) => ({
 * actions: bindActionCreators({
 *  action1,
 *  action2
 *  }, dispatch)
 * )}
 * ```
 *
 * The usage is (T is the class with the actions):
 * ```
 *  connect(mapStateToProps, bindActions(T))(Component)
 * ```
 *
 * @param {{new(): T}} actionHolderBuilder the action class
 * @returns {(dispatch: Dispatch) => {actions: {}, notifications: {}}} the binded actions
 */
export function bindActions<T>(actionHolderBuilder: { new(): T; }) {
    return (dispatch: Dispatch) => ({
        actions: bindActionCreators(toMap(actionHolderBuilder), dispatch),
        notification: bindActionCreators(toMap(NotificationActions), dispatch)
    });
}


export function createWhattsappLink(message: string) {
    return `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;

}


// WEBPACK FOOTER //
// ./src/utils/utils.ts